"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productCard.name': '产品卡片',
};
